import { ConnectToConnectBoardMutation } from "@/generated/graphql";
import { ErrorCode } from "@/libs/errors";
import { graphql, HttpResponse } from "msw";

// Mock Payloads
const successConnectDataPayload = {
  connectToConnectBoard: {},
};

const successConnectErrorPayload = {
  errors: [
    {
      extensions: {
        code: ErrorCode[ErrorCode.CONNBOARD_USER_IS_ALREADY_CONNECTED],
      },
    },
    {
      extensions: {
        code:
          ErrorCode[ErrorCode.CONNBOARD_REQUEST_FAILED] +
          ": service time is over. [210]",
      },
    },
  ],
};

const errorConnectAnotherUserPayload = {
  errors: [
    {
      extensions: {
        code: ErrorCode[
          ErrorCode.CONNBOARD_USER_IS_CONNECTED_TO_ANOTHER_SUBJECT
        ],
      },
    },
  ],
};

// Mock Cases
enum ConnectToConnectBoardMockCase {
  SuccessConnect,
  ErrorAnotherUserConnected,
}

let targetCase: number;

export const connectToConnectBoardHandler =
  graphql.mutation<ConnectToConnectBoardMutation>(
    "connectToConnectBoard",
    ({ query, variables }) => {
      targetCase = ConnectToConnectBoardMockCase.SuccessConnect;
      switch (targetCase) {
        case ConnectToConnectBoardMockCase.SuccessConnect:
          return HttpResponse.json({
            data: successConnectDataPayload,
            errors: successConnectErrorPayload.errors,
          });
        case ConnectToConnectBoardMockCase.ErrorAnotherUserConnected:
          return HttpResponse.json({
            errors: errorConnectAnotherUserPayload.errors,
          });
        default:
          return HttpResponse.json({
            errors: [{ message: "Unknown case" }],
          });
      }
    }
  );
